import React from 'react';
import { Hero } from '../components/Hero';
import { ServicePlan } from '../components/ServicePlan';
import { Check, Clock, Shield } from 'lucide-react';
export const Home = () => {
  return <div className="w-full" data-id="element-309">
      {/* Hero Section */}
      <Hero title="Fast, Reliable Appliance Repairs Across the UK" subtitle="Expert technicians, fixed prices, and unmatched customer service for all your appliance repair needs." buttonText="Book a Repair" backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/8eissqX2iHR4AEVAdH5Mr3/1.jpg" data-id="element-310" />
      {/* Introduction Section */}
      <section className="py-16 bg-light" data-id="element-311">
        <div className="container mx-auto px-4" data-id="element-312">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-313">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-314">
              Welcome to Prismedge
            </h2>
            <p className="text-lg text-gray-600" data-id="element-315">
              We provide professional appliance repair and maintenance services
              across the UK. Our team of qualified technicians is dedicated to
              delivering prompt, reliable solutions for all your household
              appliance needs. With fixed-price plans and UK-based support, you
              can count on us for exceptional service every time.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12" data-id="element-316">
            <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-317">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-318">
                <div className="text-primary" size={28} data-id="element-319" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2" data-id="element-320">
                Expert Technicians
              </h3>
              <p className="text-gray-600" data-id="element-321">
                Our highly skilled engineers are certified and experienced in
                repairing all major appliance brands.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-322">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-323">
                <Clock className="text-primary" size={28} data-id="element-324" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2" data-id="element-325">
                Fast Response
              </h3>
              <p className="text-gray-600" data-id="element-326">
                We aim to schedule repair visits within 24-48 hours of your call
                to minimize disruption.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-327">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-328">
                <Shield className="text-primary" size={28} data-id="element-329" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2" data-id="element-330">
                Fixed Pricing
              </h3>
              <p className="text-gray-600" data-id="element-331">
                Our service plans offer transparent pricing with no hidden costs
                or unexpected charges.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center" data-id="element-332">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-333">
                <Check className="text-primary" size={28} data-id="element-334" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-2" data-id="element-335">
                Quality Guaranteed
              </h3>
              <p className="text-gray-600" data-id="element-336">
                We stand behind our work with satisfaction guarantees on all
                repairs and services.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Service Plans Section */}
      <section className="py-16 bg-white" data-id="element-337">
        <div className="container mx-auto px-4" data-id="element-338">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-339">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-340">
              Our Service Plans
            </h2>
            <p className="text-lg text-gray-600" data-id="element-341">
              Choose the perfect protection plan for your home appliances. Our
              service plans offer comprehensive coverage, expert repairs, and
              peace of mind.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-342">
            <ServicePlan title="One-Year Service Plan – 1 Appliance" price="£99.00" description="Reliable cover for your appliance with 12 months of unlimited repairs, priority support, and expert engineer care." imageUrl="https://images.unsplash.com/photo-1610557892470-55d9e80c0bce?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" imageAlt="Washing machine" buttonText="Get Started" paymentLink="https://buy.stripe.com/5kQ6oG4SbgXF0uCciV1Nu01" data-id="element-343" />
            <ServicePlan title="One-Year Service Plan – TV + Set-Top Box" price="£120.00" description="Protect your home entertainment with unlimited repairs and rapid-response service for your TV and set-top box." imageUrl="https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" imageAlt="Family watching TV" buttonText="Get Started" paymentLink="https://buy.stripe.com/7sY6oGacvdLt918dmZ1Nu00" data-id="element-344" />
          </div>
        </div>
      </section>
      {/* Protect Your Home Section */}
      <section className="py-16 bg-primary text-white" data-id="element-345">
        <div className="container mx-auto px-4" data-id="element-346">
          <div className="flex flex-col lg:flex-row items-center" data-id="element-347">
            <div className="lg:w-1/2 mb-8 lg:mb-0 lg:pr-12" data-id="element-348">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-349">
                Protect the Items in Your Home
              </h2>
              <p className="text-white/90 text-lg mb-6" data-id="element-350">
                At Prismedge, we understand how essential your household
                appliances are to your daily life. That's why our team of highly
                skilled and experienced technicians is committed to delivering
                exceptional repair services you can rely on.
              </p>
              <p className="text-white/90 text-lg mb-6" data-id="element-351">
                We don't just fix appliances, we provide lasting solutions that
                keep your home running smoothly and efficiently. When you choose
                Prismedge, you gain more than just expert repairs.
              </p>
              <p className="text-white/90 text-lg" data-id="element-352">
                Our comprehensive service plans are designed to offer you
                complete peace of mind, covering your appliances with reliable
                protection and prompt support whenever you need it. We
                prioritise transparency, honesty, and clear communication, so
                you always know what to expect.
              </p>
            </div>
            <div className="lg:w-1/2" data-id="element-353">
              <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Technician repairing appliance" className="rounded-lg shadow-xl" data-id="element-354" />
            </div>
          </div>
        </div>
      </section>
    </div>;
};